import * as slider from '@zag-js/slider';
import { normalizeProps, useMachine } from 'zag-ripple';
import { track } from 'ripple';

export component Slider() {
	let service = useMachine(slider.machine, {
		id: 'slider',
		min: -50,
		max: 50,
		defaultValue: [20],
	});
	let api = track(() => slider.connect(service, normalizeProps));

	<div {...@api.getRootProps()}>
		<div>
			<label {...@api.getLabelProps()}>{"Quantity"}</label>
			<output {...@api.getValueTextProps()}>
				<b>{@api.value.at(0)}</b>
			</output>
		</div>

		<div {...@api.getControlProps()}>
			<div {...@api.getTrackProps()}>
				<div {...@api.getRangeProps()} />
			</div>
			<div {...@api.getThumbProps({ index: 0 })}>
				<input {...@api.getHiddenInputProps({ index: 0 })} />
			</div>
		</div>
	</div>
}
